import React, { useState, useEffect } from 'react';
import { Car, Search, Filter, ShieldCheck, Clock, XCircle } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import api from '../../api/axios';
import toast from 'react-hot-toast';
import styles from './Vehicles.module.css';

const Vehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/admin/vehicles');
      setVehicles(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleAction = async (id, status) => {
    try {
      const { data } = await api.put(`/admin/vehicles/${id}/status`, { status });
      setVehicles(vehicles.map(v => v._id === id ? data : v));
      toast.success('Vehicle status updated successfully!');
    } catch (error) {
      toast.error('Failed to update status');
    }
  };

  return (
    <div className={styles.container}>
      <PageHeader 
        title="Vehicle Management" 
        breadcrumb={['Society Management', 'Vehicles']} 
      />

      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div className={styles.searchBox}>
            <Search size={16} className={styles.searchIcon} />
            <input type="text" placeholder="Search vehicle no or unit..." />
          </div>
        </div>

        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Unit</th>
                <th>Vehicle Type</th>
                <th>Registration No.</th>
                <th>Make & Model</th>
                <th>Sticker Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? <tr><td colSpan="6">Loading...</td></tr> : vehicles.map(v => (
                <tr key={v._id}>
                  <td><strong>{v.resident ? `${v.resident.wing || ''}-${v.resident.flatNumber || ''}` : '-'}</strong></td>
                  <td>
                    <div className={styles.typeWrapper}>
                      <Car size={16} className={styles.iconCar} />
                      {v.type}
                    </div>
                  </td>
                  <td><strong>{v.number}</strong></td>
                  <td>{v.model}</td>
                  <td>
                    <span className={`${styles.badgeStatus} ${styles[(v.sticker || 'PENDING').toLowerCase()]}`}>
                      {v.sticker === 'VALID' && <ShieldCheck size={12} />}
                      {v.sticker === 'PENDING' && <Clock size={12} />}
                      {v.sticker === 'EXPIRED' && <XCircle size={12} />}
                      {v.sticker === 'VALID' ? 'Approved' : v.sticker === 'EXPIRED' ? 'Rejected' : 'Pending'}
                    </span>
                  </td>
                  <td>
                    {v.sticker === 'PENDING' ? (
                      <div className={styles.actionBtns}>
                        <button className={styles.btnApprove} onClick={() => handleAction(v._id, 'VALID')}>
                          Approve
                        </button>
                        <button className={styles.btnReject} onClick={() => handleAction(v._id, 'EXPIRED')}>
                          Reject
                        </button>
                      </div>
                    ) : (
                      <span className={styles.textMuted}>-</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className={styles.mobileList}>
            {loading ? <div style={{padding: '20px', textAlign: 'center'}}>Loading...</div> : vehicles.map(v => (
              <div key={v._id} className={styles.mobileCard}>
                <div className={styles.cardTop}>
                  <div className={styles.vehicleMeta}>
                    <div className={styles.typeWrapper}>
                      <Car size={16} className={styles.iconCar} />
                      <strong>{v.number}</strong>
                    </div>
                    <span>{v.model} • {v.type}</span>
                  </div>
                  <span className={`${styles.badgeStatus} ${styles[(v.sticker || 'PENDING').toLowerCase()]}`}>
                    {v.sticker === 'VALID' && <ShieldCheck size={12} />}
                    {v.sticker === 'PENDING' && <Clock size={12} />}
                    {v.sticker === 'EXPIRED' && <XCircle size={12} />}
                    {v.sticker === 'VALID' ? 'Approved' : v.sticker === 'EXPIRED' ? 'Rejected' : 'Pending'}
                  </span>
                </div>
                <div className={styles.cardMid}>
                  <p><strong>Unit:</strong> {v.resident ? `${v.resident.wing || ''}-${v.resident.flatNumber || ''}` : '-'}</p>
                </div>
                <div className={styles.cardBottom}>
                  {v.sticker === 'PENDING' ? (
                    <div className={styles.actionBtns}>
                      <button className={styles.btnApprove} onClick={() => handleAction(v._id, 'VALID')}>
                        Approve
                      </button>
                      <button className={styles.btnReject} onClick={() => handleAction(v._id, 'EXPIRED')}>
                        Reject
                      </button>
                    </div>
                  ) : (
                    <span className={styles.textMuted}>No actions required</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vehicles;
